"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Table = require("../Table.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getWidth = function getWidth(width) {
  if (Number.isNaN(width)) {
    return width;
  }

  return "".concat(width, "px");
}; // width - padding of td


var calcWidth = function calcWidth(width, index) {
  var padding = _Table.tdPr + _Table.tdPl;

  if (index === 0) {
    // First td
    padding = _Table.tdPr + _Table.firstTdPl + _Table.firtdTdBorder;
  }

  return "calc(".concat(getWidth(width), " - ").concat(padding, "px)");
};

var TableCell = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var cell = _ref.cell,
      dragHandle = _ref.dragHandle,
      index = _ref.index;
  return (0, _jsxRuntime.jsx)("td", _objectSpread(_objectSpread({}, cell.getCellProps([{
    className: cell.column.className,
    style: cell.column.style
  }])), {}, {
    children: cell.column.width === 'auto' || String(cell.column.width).indexOf('%') > -1 ? cell.render('Cell', {
      dragHandle: dragHandle
    }) : // Truncate cell when the width is explicit
    (0, _jsxRuntime.jsx)("div", {
      style: {
        width: calcWidth(cell.column.width, index)
      },
      className: "grui truncate",
      children: cell.render('Cell', {
        dragHandle: dragHandle
      })
    })
  }));
});

TableCell.displayName = 'TableCell';
TableCell.propTypes = {
  cell: (0, _propTypes.shape)({}).isRequired,
  dragHandle: (0, _propTypes.shape)({
    attributes: (0, _propTypes.shape)({}),
    listeners: (0, _propTypes.shape)({})
  }),
  index: _propTypes.number.isRequired
};
TableCell.defaultProps = {
  dragHandle: null
};
var _default = TableCell;
exports["default"] = _default;
//# sourceMappingURL=TableCell.js.map